<template>
  <FlotoAnchorLink :aria-label="$t('allocate')" @click="triggerAction">
    <!-- <MIcon name="bell" class="action-menu-icon" /> -->
    <span class="ml-1 action-menu-text">
      {{ $t('allocate') }}
    </span>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'Allocate',
  methods: {
    triggerAction() {
      this.$emit('handle-allocate-action')
      this.$emit('trigger')
    },
  },
}
</script>
